import checkInStore from "stores/new-check-in";
import { observer } from "mobx-react";
import StepsNav from "components/elements/steps-nav";

const CheckInNav = ({ stepNavs }) => {
  return <StepsNav modifier="checkIn" steps={stepNavs} />;
};

export default observer(CheckInNav);
